export default "__VITE_ASSET__Cz3ZYNGA__"